import React from "react";
import { JotformEmbed } from "./JotformEmbed";

function Contact(props) {
  return <JotformEmbed src='https://form.jotform.com/210423664810145' scrolling="yes" />;
}

export { Contact };
